/*
Copyright 2022 by Herbert Potechius,
Ernst-Abbe-Hochschule Jena - University of Applied Sciences - Department of Electrical Engineering and Information
Technology - Immersive Media and AR/VR Research Group.
All rights reserved.
This file is released under the "MIT License Agreement".
Please see the LICENSE file that should have been included as part of this package.
*/


/* ----------------------------------------------------------------------------------------------------------------
-------------------------------------------------------------------------------------------------------------------
-- Contains the paths of all images and logos
-- Source: https://www.flaticon.com/
-------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------------------------------------------------------------------*/
class Images {
    // HP logo in the top left corner of the Header 
    static logo_header = "/assets/logo_old.png";
    static logo2_header = "/assets/ct_logo.png";
    static button_wireframe = "/assets/wireframe.png"
    static button_texture = "/assets/texture.png"
    static button_xray = "/assets/x-ray.jpg"
    static button_data = "/assets/data.png"
    static button_info = "/assets/info.png"

}


export default Images